import { useCallback, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

import ConfirmationDialog from '@sayyesschool/frontend/components/confirmation-dialog';
import FormDialog from '@sayyesschool/frontend/components/form-dialog';
import LoadingIndicator from '@sayyesschool/frontend/components/loading-indicator';
import Page from '@sayyesschool/frontend/components/page';
import PageContent from '@sayyesschool/frontend/components/page-content';
import PageHeader from '@sayyesschool/frontend/components/page-header';
import { useMaterial } from '@sayyesschool/frontend/features/materials';
import { useBoolean } from '@sayyesschool/frontend/hooks/state';

import MaterialDetails from '@/components/materials/material-details';
import MaterialForm from '@/components/materials/material-form';

export default function MaterialPage() {
    const navigate = useNavigate();
    const params = useParams();
    const [material, actions] = useMaterial(params.id);

    const [isEditFormOpen, toggleEditFormOpen] = useBoolean(false);
    const [isConfirmationDialogOpen, toggleConfirmationDialogOpen] = useBoolean(false);

    useEffect(() => {
        actions.getMaterial(params.id);
    }, [params.id, actions]);

    const handleUpdate = useCallback(data => {
        return actions.updateMaterial(material.id, data)
            .then(() => toggleEditFormOpen(false));
    }, [material, actions, toggleEditFormOpen]);

    const handleDelete = useCallback(() => {
        return actions.deleteMaterial(material.id)
            .then(() => navigate('/materials'));
    }, [material, actions, navigate]);

    if (!material) return <LoadingIndicator />;

    return (
        <Page id="material-page">
            <PageHeader
                title={material.title}
                toolbar={[
                    {
                        key: 'delete',
                        icon: 'delete',
                        title: 'Удалить встречу',
                        onClick: toggleConfirmationDialogOpen
                    }
                ]}
            />

            <PageContent>
                <MaterialDetails material={material} />
            </PageContent>

            <FormDialog
                title="Редактирование материала"
                open={isEditFormOpen}
                onClose={toggleEditFormOpen}
            >
                <MaterialForm onSubmit={handleUpdate} />
            </FormDialog>

            <ConfirmationDialog
                title="Удалить материал?"
                open={isConfirmationDialogOpen}
                onConfirm={handleDelete}
                onClose={() => toggleConfirmationDialogOpen(false)}
            />
        </Page>
    );
}